import React from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import {
	wrapperStyle,
	ellipsisStyle,
	currentPageStyle,
	previousLinkStyle,
	nextLinkStyle,
} from './styles';

export class Pagination extends React.PureComponent {
	static propTypes = {
		initialPage: PropTypes.number,
		pageCount: PropTypes.number,
		onPageChange: PropTypes.func,
	};

	static defaultProps = {
		currentPage: 1,
	};

	render() {
		const { initialPage, pageCount, onPageChange } = this.props;

		return (
			<nav className={wrapperStyle}>
				<ReactPaginate
					previousLabel={'<'}
					nextLabel={'>'}
					previousLinkClassName={previousLinkStyle}
					nextLinkClassName={nextLinkStyle}
					breakLabel={<a href="">...</a>}
					breakClassName={ellipsisStyle}
					initialPage={initialPage - 1}
					pageCount={pageCount}
					marginPagesDisplayed={1}
					pageRangeDisplayed={5}
					onPageChange={page => onPageChange(page.selected + 1)}
					containerClassName={''}
					subContainerClassName={'pages pagination'}
					activeClassName={currentPageStyle}
					disableInitialCallback={true}
				/>
			</nav>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/shared/pagination/component.js